<template>
  <div class="col-lg-12">
    <div class="card card-body card-panel-box border-0">
      <div class="d-flex justify-content-between align-items-center">
        <h2 style="font-size: 1.2vw !important;">مشخصات کلی </h2>
        <button style="background-color:#626aff !important;" class="btn btn-primary btn-submit-1" @click.prevent="$router.back()"  > برگشت
        </button>
      </div>
      <form class="needs-validation mt-2 mb-3" novalidate>
        <div class="row">
          <div v-show="category_info" class="col-lg-2 mb-3 ms-n-1">
            <label class="form-label">طبقه بندی فرآیند</label>
            <input v-model="category_info" class="form-control" type="text" name="" disabled>
          </div>
          <div v-show="group_info" class="col-lg-2 mb-3 ms-n-1">
            <label class="form-label">گروه فرآیند</label>
            <input v-model="group_info" class="form-control" type="text" name="" disabled>
          </div>
          <div v-show="process_info" class="col-lg-2 mb-3 ms-n-1">
            <label class="form-label">فرآیند</label>
            <input v-model="process_info" class="form-control" type="text" name="" disabled>
          </div>
          <div v-show="sub_process_info" class="col-lg-2 mb-3 ms-n-1">
            <label class="form-label">زیرفرآیند</label>
            <input v-model="sub_process_info" class="form-control" type="text" name="" disabled>
          </div>

        </div>
        <div class="row">
          <div class="col-3 mb-3 ms-n-1">
            <label class="form-label required">ماموریت فرآیند</label>

            <textarea v-model="target_mission" class="form-control" id="" cols="30" rows="30"
                      style="height: 3vw;"></textarea>
          </div>
          <div class="col-3 mb-3 ms-n-1">
            <label class="form-label required">دامنه کاربرد فرآیند</label>

            <textarea v-model="domain_of_usage" class="form-control" id="" cols="30" rows="30"
                      style="height: 3vw;"></textarea>
          </div>
          <div class="col-3 mb-3 ms-n-1">
            <label class="form-label required">هدف فرآیند</label>

            <textarea v-model="target_process" class="form-control" id="" cols="30" rows="30"
                      style="height: 3vw;"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 mb-3 ms-n-1">
            <label class="form-label required">مالک فرآیند</label>

            <input v-model="organizationName" class="form-control" type="text" name="" readonly
                   placeholder="انتخاب کنید" @click.prevent="showListOrganization">

          </div>
          <div class="col-lg-3 mb-3 ms-n-1">
            <label class="form-label required">آیا فرآیند مربوطه استراتژیک است؟</label>
            <select v-model="is_strategic" class="form-select" name="" required>
              <option value="1">بلی</option>
              <option value="0">خیر</option>
            </select>
          </div>
          <div v-if="parseInt(is_strategic)===1" class="col-lg-3 mb-3 ms-n-1">
            <label class="form-label">عنوان هدف استراتژیک</label>
            <input  v-model="strategic_title_target" class="form-control" type="text" name="" required>
          </div>

          <div class="col-lg-1-2 mb-3 ms-n-1">&nbsp</div>
          <div class="col-lg-1 mb-3">
            <button class="btn btn-primary btn-submit-1" @click.prevent="saveItem" style="margin-top: 1.9vw; transform: translateX(-7vw)">ذخیره
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="select_organization"
       style="z-index: 999999999999999999999999999999999999999999999; top: 4%;">
    <div>
      <p>انتخاب مالک فرآیند</p>
      <p @click="select_organization=!select_organization">❌</p>
    </div>
    <div>
      <input v-model="search_organization" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی...">
      <div style="overflow-y:scroll; width: 100%; height: 10vw;">

      <table class="table table-striped">
        <thead>
        <tr class="sticky-header">
          <th style="width: 1vw;">انتخاب</th>
          <th>پست سازمانی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredorganization" :key="item.id">
          <td scope="row"><input :id="`item_${item.id}`" v-model="organizationId" type="radio" name="parent" :value="item['id']"></td>
          <td>
            <label :for="`item_${item.id}`" > {{ item['name'] }}</label>
           </td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_organizationMethod">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 4%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>

<script>
import {useToast} from "vue-toastification";

export default {
  props: ['id_route'],
  data() {
    return {
      category_info: '',
      group_info: '',
      process_info: '',
      sub_process_info: '',
      slug_name: '',
      all_organization: [],
      select_organization: false,
      search_organization: '',
      organizationId: '',
      organizationName: '',
      target_mission: '',
      domain_of_usage: '',
      target_process: '',
      is_strategic: '',
      strategic_title_target: '',
      error: false,
      errorMessage: '',
    }
  },
  methods: {
    saveItem() {
      if (parseInt(this.is_strategic)===1 && !this.strategic_title_target){
        this.error=true
        this.errorMessage='عنوان هدف استراتژیک اجباری است'
        return
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      const toast = useToast();


      var formdata = new FormData();
      formdata.append('organizationposts_id', this.organizationId)
      formdata.append('processes_id', this.id_route)
      formdata.append('target_mission', this.target_mission)
      formdata.append('domain_of_usage', this.domain_of_usage)
      formdata.append('target_process', this.target_process)
      formdata.append('strategic_title_target', this.strategic_title_target)
      formdata.append('is_strategic', this.is_strategic)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/general_profile/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){

              this.errorMessage=response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              toast.error(this.errorMessage)

              return;
            }
            toast.success('عملیات با موفقیت انجام شد!')
          })
          .catch();

    },

    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/general_profile/show/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.item){
              this.target_mission = response.item.target_mission
              this.domain_of_usage = response.item.domain_of_usage
              this.target_process = response.item.target_process
              this.strategic_title_target = response.item.strategic_title_target
              this.is_strategic = response.item.is_strategic
              this.organizationName = response.item.organizationpost.name
              this.organizationId = response.item.organizationpost.id
            }


          })
          .catch();

    },
    getInformations() {
      fetch(`${this.base_url}/processes/information_by_id/${this.id_route}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response) {
              if (response.item) {
                this.slug_name = response.item.title

              }
              if (response.category) {
                this.category_info = response.category.title

              }
              if (response.group) {
                this.group_info = response.group.title

              }
              if (response.process) {
                this.process_info = response.process.title

              }
              if (response.sub_process) {
                this.sub_process_info = response.sub_process.title

              }
            }

          }).catch((err) => {
      })
    },
    showListOrganization() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.all_organization.length = 0

            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_organization.push(item)
                this.select_organization = true

              })

            }

          })
          .catch();
    },
    select_organizationMethod() {
      this.all_organization.forEach((ele) => {
        ele.id === this.organizationId ? this.organizationName = ele.name : ''
      })
      this.select_organization = false


    },

  },
  computed: {
    filteredorganization() {
      return this.all_organization.filter(item => {
        return (
            item['name'].includes(this.search_organization) ||
            item['id'].toString().includes(this.search_organization)
        );
      });
    },
  },
  mounted() {
    this.getInformations()
    this.showItem()
  },
}

</script>

<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>